// Popups that interrupt play: choice events, the rekt screen, rank-up cards.
import { dispatch, gameState, hud, rankUp, showToast } from "../bridge";
import { PfpImage } from "../PfpImage";
import { wusd } from "../format";
import { rankName } from "@degen/sim/rank";
import { REKT_LINES, RANK_UP_LINES } from "@degen/shared/config/content";
import { deleteSave } from "../../saveStore";
import { recordLife } from "../lives";

export function EventModal() {
  const ev = hud.value?.event;
  if (!ev) return null;
  const scam = ev.kind !== "collab";
  return (
    <div class="modal-backdrop" role="dialog" aria-modal="true" aria-label={ev.title}>
      <div class={`modal event ${ev.kind}`}>
        <div class="modal-kicker">{ev.kind === "fake_claim" ? "🌐 Browser" : ev.kind === "collab" ? "📨 DM" : "📨 DM request"}</div>
        <h3>{ev.title}</h3>
        <div class="dm">
          <b>@{ev.from}</b>
          <p>{ev.body}</p>
        </div>
        {scam && <p class="muted small">The game is paused. Take your time.</p>}
        <div class="modal-actions">
          {ev.options.map((o) => (
            <button
              key={o.id}
              class={`btn ${o.id === "click" || o.id === "accept" ? "danger" : o.id === "report" ? "primary" : ""}`}
              onClick={() => {
                const r = dispatch({ type: "RESOLVE_EVENT", eventId: ev.id, choice: o.id });
                if (r.ok && r.data?.lost) navigator.vibrate?.([80, 40, 160]);
              }}
            >
              {o.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export function RektScreen() {
  const r = hud.value?.rekt;
  if (!r) return null;
  const s = gameState()!;
  const line = REKT_LINES[r.tick % REKT_LINES.length];
  const newLife = async () => {
    recordLife(s, r.cause === "cooked" ? "cooked" : "rekt");
    await deleteSave();
    location.href = `${location.pathname}?new=1`;
  };
  return (
    <div class="modal-backdrop rekt" role="dialog" aria-modal="true" aria-label="Rekt">
      <div class="modal rekt-card">
        <div class="rekt-title">REKT</div>
        <p class="rekt-line">{line}</p>
        <div class="kv">
          <div>
            <span class="muted small">Peak net worth</span>
            <b class="num">{wusd(r.peakNetWorth)}</b>
          </div>
          <div>
            <span class="muted small">Days survived</span>
            <b class="num">{r.daysPlayed}</b>
          </div>
          <div>
            <span class="muted small">Biggest win</span>
            <b class="num up">{wusd(r.bestTradeUsd)}</b>
          </div>
          <div>
            <span class="muted small">Biggest loss</span>
            <b class="num down">{wusd(r.worstTradeUsd)}</b>
          </div>
          <div>
            <span class="muted small">Rugs survived</span>
            <b class="num">{r.rugsSurvived}</b>
          </div>
          <div>
            <span class="muted small">Comebacks</span>
            <b class="num">{s.player.comebacks}</b>
          </div>
        </div>
        <button
          class="btn primary big"
          onClick={() => {
            if (dispatch({ type: "COMEBACK" }).ok) {
              navigator.vibrate?.(60);
              showToast("The comeback arc begins. +25% engagement for 7 days.");
            }
          }}
        >
          🔁 Comeback arc
        </button>
        <p class="muted small">Keep 30% of your followers, trust resets to 40, cash {wusd(0)}, +25% engagement for 7 days.</p>
        <button class="btn ghost" onClick={newLife}>
          🌱 New life
        </button>
      </div>
    </div>
  );
}

export function RankUpCard() {
  const r = rankUp.value;
  const s = gameState();
  if (r === null || !s) return null;
  const p = s.player;
  return (
    <div class="modal-backdrop" role="dialog" aria-modal="true" aria-label="Rank up" onClick={() => (rankUp.value = null)}>
      <div class="modal rankup-card">
        <div class="modal-kicker">RANK UP</div>
        <PfpImage seed={p.pfp.seed} traits={p.pfp.traits} size={140} />
        <div class="rankup-rank">{rankName(r)}</div>
        <div>
          <b>{p.name}</b> <span class="muted">@{p.handle}</span>
        </div>
        <p class="muted">{RANK_UP_LINES[(r + p.day) % RANK_UP_LINES.length]}</p>
        <div class="muted small">Day {p.day} · Degen World</div>
        <button class="btn primary" onClick={() => (rankUp.value = null)}>
          LFG
        </button>
      </div>
    </div>
  );
}
